import React from 'react';
import { Typography, InputNumber } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styles from '../SimpleCondition.module.less';

const { Paragraph } = Typography;

function DeviceDisconnectionInputValues(props) {

  const { params, onChangeOrCondition, fieldSelected } = props;
  const isEditDefault = useSelector(({ alarms }) => alarms.isEditDefault);
  const ExpRegSoloNumeros="^[0-9]+$";

  return (
    <>
       <div className={`${styles.take_two_columns} ${styles.input_threshold}`}>
          <InputNumber
            step={1}
            min={30}
            value={params.max_minutes}
            onChange={(value) => {

              if(`${value}`.match(ExpRegSoloNumeros)!=null){
                onChangeOrCondition('max_minutes', value)
              }else if(`${value}` ==''){
                onChangeOrCondition('max_minutes', '')
              }

            }}
            disabled={isEditDefault}
          />
          <Paragraph strong>min</Paragraph>
        </div>
    </>
  );

}

DeviceDisconnectionInputValues.propTypes = {
  params: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeOrCondition: PropTypes.func.isRequired,
  fieldSelected: PropTypes.objectOf(PropTypes.any),
};

DeviceDisconnectionInputValues.defaultProps = {
  fieldSelected: null,
};

export default DeviceDisconnectionInputValues;
